import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-spin", {
    attrs: {
      spinning: _vm.totalLoading
    }
  }, [_c("div", [_c("a-card", {
    staticStyle: {
      height: "100%"
    },
    attrs: {
      bordered: false
    }
  }, [_c("a-form-model", {
    ref: "editDyx",
    attrs: {
      model: _vm.form
    }
  }, [_c("a-row", {
    staticClass: "editDyx",
    attrs: {
      gutter: 128
    }
  }, [_c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.email")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.form.customerEmail,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customerEmail", $$v);
      },
      expression: "form.customerEmail"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.phone")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.form.customerPhone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customerPhone", $$v);
      },
      expression: "form.customerPhone"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_vm.form.customerEmail || _vm.form.customerPhone ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.approvalStatus")
    }
  }, [_vm.form.approvalResult !== "" && _vm.form.approvalResult !== null && _vm.form.approvalResult !== undefined ? _c("a-tag", {
    attrs: {
      color: _vm.form.approvalResult == 1 ? "orange" : _vm.form.approvalResult == 2 ? "blue" : "red"
    }
  }, [_vm._v(_vm._s(_vm.form.approvalResult == 1 ? _vm.$t("customerList.approval") : _vm.form.approvalResult == 2 ? _vm.$t("customerList.pass") : _vm.$t("customerList.refuse")))]) : _c("span", [_vm._v("--")])], 1) : _vm._e()], 1)], 1), _c("a-row", {
    staticClass: "editDyx",
    attrs: {
      gutter: 128
    }
  }, [_c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.appversion")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.appinfo,
      callback: function callback($$v) {
        _vm.appinfo = $$v;
      },
      expression: "appinfo"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.sellerName2")
    }
  }, [_c("a-textarea", {
    attrs: {
      "auto-size": "",
      disabled: true
    },
    model: {
      value: _vm.customerNickname,
      callback: function callback($$v) {
        _vm.customerNickname = $$v;
      },
      expression: "customerNickname"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.remark")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: _vm.remarkNicknameDisabled,
      maxLength: 100,
      allowClear: ""
    },
    model: {
      value: _vm.remarkNickname,
      callback: function callback($$v) {
        _vm.remarkNickname = $$v;
      },
      expression: "remarkNickname"
    }
  })], 1)], 1)], 1), _c("a-row", {
    staticClass: "editDyx",
    attrs: {
      gutter: 128
    }
  }, [_c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customer.password")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 20,
      disabled: !_vm.form.customerEmail && !_vm.form.customerPhone,
      allowClear: ""
    },
    model: {
      value: _vm.password,
      callback: function callback($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  })], 1)], 1), _vm.registerErpCustomerVo ? _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: " ",
      colon: false
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.showCustomerFirstTimeInfo
    }
  }, [_vm._v(_vm._s(_vm.$t("customer.showFirstTime")))])], 1)], 1) : _vm._e()], 1), _c("a-tabs", {
    attrs: {
      animated: false,
      activeKey: _vm.activeKey
    },
    on: {
      change: _vm.changeTab
    }
  }, [_c("a-tab-pane", {
    key: "1",
    staticClass: "customerInfo",
    attrs: {
      tab: _vm.$t("customerList.customerInfo2")
    }
  }, [_c("a-row", {
    attrs: {
      gutter: 128
    }
  }, [_c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    staticStyle: {
      position: "relative"
    },
    attrs: {
      label: _vm.$t("customerList.dyxProductNo"),
      prop: "erpCustomerCode",
      rules: {
        required: true,
        message: _vm.$t("customerList.rule4"),
        trigger: "change"
      }
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.form.erpCustomerCode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "erpCustomerCode", $$v);
      },
      expression: "form.erpCustomerCode"
    }
  }), _vm.form.erpCustomerStatus == 1 && (_vm.form.customerPhone !== "" || _vm.form.customerEmail !== "") ? _c("a-button", {
    staticStyle: {
      position: "absolute",
      top: "-7px",
      right: "-80px"
    },
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.bindErp
    }
  }, [_vm._v(_vm._s(_vm.$t("customerList.bind")))]) : _vm._e()], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.dyxName")
    }
  }, [_c("a-textarea", {
    attrs: {
      "auto-size": {
        minRows: 1
      },
      disabled: true
    },
    model: {
      value: _vm.form.erpCustomerName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "erpCustomerName", $$v);
      },
      expression: "form.erpCustomerName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.erpCustomerStatus")
    }
  }, [_vm.form.erpCustomerStatus && _vm.form.erpCustomerCode ? _c("a-tag", {
    attrs: {
      color: _vm.form.erpCustomerStatus == 1 ? "blue" : "red"
    }
  }, [_vm._v(_vm._s(_vm.form.erpCustomerStatus == 1 ? _vm.$t("customerList.normal") : _vm.$t("customerList.notNormal")))]) : _c("span", [_vm._v("--")])], 1)], 1)], 1), _c("a-row", {
    attrs: {
      gutter: 128
    }
  }, [_c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.transportType"),
      prop: "deliveryWayStr",
      rules: [{
        required: _vm.form.erpCustomerStatus == 1 && _vm.form.erpCustomerCode !== "" && _vm.form.erpCustomerCode !== null && _vm.form.erpCustomerCode !== undefined,
        message: _vm.$t("customerList.selectTransport"),
        trigger: "change"
      }, {
        required: false,
        validator: _vm.onCheckDeliveryWay,
        trigger: "blur"
      }]
    }
  }, [_c("a-select", {
    attrs: {
      disabled: !(_vm.form.erpCustomerStatus == 1 && _vm.form.erpCustomerCode !== "" && _vm.form.erpCustomerCode !== null && _vm.form.erpCustomerCode !== undefined),
      mode: "multiple",
      maxTagCount: 1
    },
    model: {
      value: _vm.form.deliveryWayStr,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "deliveryWayStr", $$v);
      },
      expression: "form.deliveryWayStr"
    }
  }, _vm._l(_vm.transportTypeList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.value,
        disabled: item.disabled
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.erpCustomerPhone")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.form.erpCustomerPhone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "erpCustomerPhone", $$v);
      },
      expression: "form.erpCustomerPhone"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.email2")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.form.email,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1)], 1)], 1), _c("a-row", {
    attrs: {
      gutter: 128
    }
  }, [_c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.addressDetail")
    }
  }, [_c("a-textarea", {
    attrs: {
      "auto-size": {
        minRows: 2
      },
      disabled: true
    },
    model: {
      value: _vm.form.addressDetail2,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "addressDetail2", $$v);
      },
      expression: "form.addressDetail2"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.departmentName")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.form.department,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "department", $$v);
      },
      expression: "form.department"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.customerStatus5")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.form.sellerName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "sellerName", $$v);
      },
      expression: "form.sellerName"
    }
  })], 1)], 1)], 1), _c("a-row", {
    attrs: {
      gutter: 128
    }
  }, [_c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.customerStatus4")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.form.busFormatName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "busFormatName", $$v);
      },
      expression: "form.busFormatName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.payerCode")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.form.payerCode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "payerCode", $$v);
      },
      expression: "form.payerCode"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customer.paytype")
    }
  }, [_c("a-select", {
    attrs: {
      disabled: true,
      mode: "multiple"
    },
    model: {
      value: _vm.form.payWayStr,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "payWayStr", $$v);
      },
      expression: "form.payWayStr"
    }
  }, _vm._l(_vm.payMethodList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1)], 1), _c("a-row", {
    attrs: {
      gutter: 128
    }
  }, [_c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.quoteCondition")
    }
  }, [_c("a-textarea", {
    attrs: {
      "auto-size": {
        minRows: 2
      },
      disabled: true
    },
    model: {
      value: _vm.form.tradeTerm,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tradeTerm", $$v);
      },
      expression: "form.tradeTerm"
    }
  })], 1)], 1), _vm.showCode ? _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.inviteCode")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.form.inviteCode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "inviteCode", $$v);
      },
      expression: "form.inviteCode"
    }
  })], 1)], 1) : _vm._e(), _c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("customerList.dyxGrouped")
    }
  }, [_c("a-select", {
    attrs: {
      disabled: true,
      mode: "multiple",
      maxTagTextLength: 5
    },
    model: {
      value: _vm.form.customerGroupIds,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customerGroupIds", $$v);
      },
      expression: "form.customerGroupIds"
    }
  }, _vm._l(_vm.dysGroupedList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1)], 1), _vm.form.erpCustomerStatus != 3 ? _c("FooterToolBar", [[_vm.form.customerEmail || _vm.form.customerPhone ? [_vm.form.approvalResult == 1 || _vm.form.approvalResult == 2 ? _c("a-button", {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      type: "danger"
    },
    on: {
      click: function click($event) {
        return _vm.saveAll(3);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("customerList.approvalRefuse")))]) : _vm._e(), _vm.form.approvalResult == 1 || _vm.form.approvalResult == 3 ? _c("a-button", {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.saveAll(2);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("customerList.approvalPass")))]) : _vm._e()] : _vm._e(), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.saveAll(1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("customerList.save")))])]], 2) : _vm._e()], 1), _c("a-tab-pane", {
    key: "2",
    attrs: {
      tab: _vm.$t("customer.addressinformation"),
      "force-render": ""
    }
  }, [_c("a-spin", {
    attrs: {
      spinning: _vm.addressLoading
    }
  }, [_c("a-table", {
    attrs: {
      pagination: _vm.addressPagenation,
      columns: _vm.addressColumns,
      "data-source": _vm.addressData,
      "row-key": "id"
    },
    on: {
      change: _vm.tableChange
    },
    scopedSlots: _vm._u([{
      key: "addressDetail",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a-tooltip", {
          attrs: {
            title: record.addressName + record.addressDetail
          }
        }, [_c("span", [_vm._v(_vm._s(record.addressName + record.addressDetail))])])], 1);
      }
    }, {
      key: "phone",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("span", [_vm._v(_vm._s(record.phone))])]);
      }
    }, {
      key: "defaultAddress",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a-tag", {
          attrs: {
            color: "blue"
          }
        }, [_vm._v(_vm._s(record.flag == 1 ? _vm.$t("customerList.yes") : _vm.$t("customerList.no")))])], 1);
      }
    }, {
      key: "action",
      fn: function fn(text, record) {
        return _c("span", {}, [record.isDeletable === 1 ? _c("a-popconfirm", {
          attrs: {
            title: _vm.$t("customerList.confirmDelAddress"),
            "ok-text": _vm.$t("public.yes"),
            "cancel-text": _vm.$t("public.no")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.confirmDeleteAddress(record);
            },
            cancel: _vm.cancelDeleteAddress
          }
        }, [_c("a", [_vm._v(_vm._s(_vm.$t("publicuse.delete")))])]) : _vm._e()], 1);
      }
    }])
  })], 1)], 1), _c("a-tab-pane", {
    key: "3",
    attrs: {
      tab: _vm.$t("erpGoods.erpGoods")
    }
  }, [_c("erpGoods", {
    ref: "selfGoods",
    attrs: {
      erpcustomerId: _vm.erpCustomerId
    }
  })], 1)], 1)], 1)], 1)], 1)]), _c("a-modal", {
    staticClass: "bindModal",
    attrs: {
      title: _vm.$t("customerList.bindErp"),
      visible: _vm.visibleErp,
      "confirm-loading": _vm.confirmLoadingErp,
      width: "600px",
      dialogStyle: {
        top: "20px"
      }
    },
    on: {
      cancel: _vm.handleCancelErp
    }
  }, [_c("a-form-model", {
    ref: "bindVisible",
    staticStyle: {
      display: "flex"
    },
    attrs: {
      model: _vm.searchForm
    }
  }, [_c("a-form-model-item", {
    staticStyle: {
      display: "flex"
    },
    attrs: {
      label: _vm.$t("customerList.dyxProductNo"),
      prop: "erpCustomerCode",
      rules: [{
        required: true,
        message: _vm.$t("customerList.error1"),
        trigger: "blur"
      }]
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "210px"
    },
    attrs: {
      placeholder: _vm.$t("customerList.pls")
    },
    model: {
      value: _vm.searchForm.erpCustomerCode,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "erpCustomerCode", $$v);
      },
      expression: "searchForm.erpCustomerCode"
    }
  })], 1), _c("a-form-item", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      icon: "search"
    },
    on: {
      click: _vm.getSearch
    }
  }, [_vm._v(_vm._s(_vm.$t("customerList.query")))])], 1)], 1), _c("a-table", {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      columns: _vm.erpColumns,
      "data-source": _vm.erpData,
      pagination: false,
      loading: _vm.bindLoading
    },
    scopedSlots: _vm._u([{
      key: "afterGet",
      fn: function fn(text, record) {
        return _c("span", {}, [record.aftername ? _c("span", [_vm._v(_vm._s(record.aftername))]) : _c("span", [_vm._v("--")])]);
      }
    }, {
      key: "preGet",
      fn: function fn(text, record) {
        return _c("span", {}, [record.prename ? _c("span", [_vm._v(_vm._s(record.prename))]) : _c("span", [_vm._v("--")])]);
      }
    }])
  }), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: _vm.handleCancelErp
    }
  }, [_vm._v(_vm._s(_vm.$t("public.cancel")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.handleOkErp
    }
  }, [_vm._v(_vm._s(_vm.$t("public.confirm")))])], 1)], 2), _c("a-modal", {
    staticClass: "bindModal",
    attrs: {
      title: _vm.$t("customer.firstTimeTime"),
      visible: _vm.firstTimeInfoVisible,
      width: "600px",
      dialogStyle: {}
    },
    on: {
      cancel: function cancel($event) {
        _vm.firstTimeInfoVisible = false;
      }
    }
  }, [_c("a-table", {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      columns: _vm.fistTimeColumns,
      "data-source": _vm.firstTimeInfo,
      pagination: false,
      showHeader: false,
      loading: _vm.bindLoading
    },
    scopedSlots: _vm._u([{
      key: "preGet",
      fn: function fn(text, record) {
        return _c("span", {}, [record.prename ? _c("span", [_vm._v(_vm._s(record.prename))]) : _c("span", [_vm._v("--")])]);
      }
    }])
  }), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onConfirmFirstTimeInfo
    }
  }, [_vm._v(_vm._s(_vm.$t("public.confirm")))])], 1)], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };